import { AbstractConnector } from '@web3-react/abstract-connector'

export class EIP6963Connector extends AbstractConnector {
  private provider: any // Explicitly declare provider

  constructor(provider: any) {
    super()
    this.provider = provider
  }

  async activate(): Promise<{ provider: any; account: string | null; chainId: number }> {
    if (!this.provider) {
      throw new Error('No provider available.')
    }

    const accounts = (await this.provider.request({ method: 'eth_requestAccounts' })) as string[]
    const chainId = (await this.provider.request({ method: 'eth_chainId' })) as string

    return { provider: this.provider, account: accounts[0] || null, chainId: parseInt(chainId, 16) }
  }

  async getProvider(): Promise<any> {
    return this.provider
  }

  async getChainId(): Promise<number> {
    const chainId = (await this.provider.request({ method: 'eth_chainId' })) as string
    return parseInt(chainId, 16)
  }

  async getAccount(): Promise<string | null> {
    const accounts = (await this.provider.request({ method: 'eth_accounts' })) as string[]
    return accounts.length > 0 ? accounts[0] : null
  }

  async deactivate(): Promise<void> {
    this.provider = null
  }

  async close(): Promise<void> {
    if (this.provider && this.provider.disconnect) {
      await this.provider.disconnect()
    }
    this.provider = null
    this.emitDeactivate()

    // Clear cached provider to prevent auto-reconnection
    window.localStorage.removeItem('connector')

    await this.disconnectWallet(this.provider)
  }

  async disconnectWallet(provider: any): Promise<void> {
    try {
      const accounts: string[] = await provider.request({ method: 'eth_accounts' })

      if (accounts.length > 0) {
        await provider.request({
          method: 'wallet_revokePermissions',
          params: [{ eth_accounts: {} }],
        })
      }
    } catch (error) {
      console.warn('Error revoking wallet permissions:', error)
    }
  }
}
